import React, { type FC } from 'react'

import styled from '@emotion/styled'

interface IconArrowPointerProps {
  width?: string
  height?: string
  fill?: string
  transform?: string
}

const MySVG = styled.svg`
  & path {
    transform-origin: center;
  }
`

const IconArrowPointer: FC<IconArrowPointerProps> = (
  { width, height, fill, transform } = { fill: 'currentColor' },
) => {
  return (
    <MySVG
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 320 512"
    >
      <path
        fill={fill}
        transform={transform}
        shapeRendering="geometricPrecision"
        d="M144 272h85.8L48 110.4V356.8l59.9-68.4C117 278 130.2 272 144 272zM0 426V55.2C0 42.4 10.4 32 23.2 32c5.7 0 11.2 2.1 15.4 5.9l274 243.6c4.7 4.2 7.4 10.2 7.4 16.5c0 12.2-9.9 22.1-22.1 22.1H170.5l59.1 126.8c5.6 12 .4 26.3-11.6 31.9s-26.3 .4-31.9-11.6L126.7 339.7 38.6 440.5C34.4 445.3 28.4 448 22 448c-12.2 0-22-9.9-22-22z"
      />
    </MySVG>
  )
}

export default IconArrowPointer
